import { Control } from 'react-hook-form';

import {
  AccountTypeFormGroup,
  ConnectedThemeSetFormGroup,
  ReferenceIdFormGroup,
  SendEmailFormGroup,
  TemplateFormGroup,
  ThemeFormGroup,
} from 'dashboard/components/CreateInquiry/CreateInquiryFormGroups';
import { AccountTypesFilterOption } from 'dashboard/models/account-type';
import { InquiryTemplateFilterOption } from 'dashboard/models/inquiry-template';
import { TemplateFilterOption } from 'dashboard/models/template';
import { Theme } from 'dashboard/models/theme';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';
import { ApiModel } from 'lib/interfaces/api';

export type CreateInquiryGeneralInfoProps = {
  templateFilterOptions: (InquiryTemplateFilterOption | TemplateFilterOption)[];
  accountTypeBasics: AccountTypesFilterOption[];
  themes: Theme[];
  submitting: boolean;
  selectedTemplate: InquiryTemplateFilterOption | TemplateFilterOption | undefined;
  control: Control;
};

function CreateInquiryGeneralInfo({
  templateFilterOptions,
  accountTypeBasics,
  themes,
  submitting,
  selectedTemplate,
  control,
}: CreateInquiryGeneralInfoProps) {
  if (templateFilterOptions.length === 0) {
    return <Paragraph>No Inquiry Templates to use for Inquiry creation.</Paragraph>;
  }

  return (
    <>
      <Paragraph>
        Create an Inquiry and a hosted flow link that can be sent to individuals to verify their
        identity.
      </Paragraph>
      <Spacer height={2} />

      <TemplateFormGroup
        templateFilterOptions={templateFilterOptions}
        control={control}
        submitting={submitting}
      />

      {themes.length > 1 && selectedTemplate?.type === ApiModel.Template && (
        <ThemeFormGroup themes={themes} control={control} submitting={submitting} />
      )}

      <ReferenceIdFormGroup control={control} submitting={submitting} />

      {accountTypeBasics.length > 1 && (
        <AccountTypeFormGroup
          accountTypeFilterOptions={accountTypeBasics}
          control={control}
          submitting={submitting}
        />
      )}

      {selectedTemplate?.type === ApiModel.InquiryTemplate && (
        <ConnectedThemeSetFormGroup control={control} submitting={submitting} />
      )}

      <SendEmailFormGroup control={control} submitting={submitting} />
    </>
  );
}

export default CreateInquiryGeneralInfo;
